import type { ThemeDefinition } from 'vuetify'

export const hausperfektTheme: ThemeDefinition = {
	colors: {
		background: '#f5f5f5',
		primary: '#00a4a5',
		secondary: '#03CED0',
		error: '#b71c1c',
		accent: '#B2B2B2',
		nav: '#424242',
		table: '#ffffff',
		text: '#121212',
	},
}
